import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { LoginCustomization } from '@core/interfaces';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { slideInRight } from '../../animations/slide-in-right.animation';
import { UserLookupService } from '../../services/api/user-lookup.api.service';
import { LoginResolver } from '../../services/login.resolver';

@Component({
  selector: 'login-recover-password',
  templateUrl: './recover-password.component.html',
  animations: [slideInRight]
})
export class LoginRecoverPasswordComponent {
  public isLoading: boolean;
  public emailControl: FormControl;
  public loginCustomization: LoginCustomization;

  constructor(
    private readonly router: Router,
    private readonly loginResolver: LoginResolver,
    private readonly activatedRoute: ActivatedRoute,
    private readonly userLookupService: UserLookupService,
    private readonly fuseProgressBar: FuseProgressBarService,
    private readonly authenticationService: AuthenticationService,
  ) {
    this.isLoading = false;
    this.loginCustomization = this.loginResolver.loginCustomization;
    this.emailControl = new FormControl(this.activatedRoute.snapshot.queryParams.email, [
      Validators.required, Validators.email
    ]);
  }

  public async recoverAccount(): Promise<void> {
    this.isLoading = true;
    this.fuseProgressBar.show();

    const email = this.emailControl.value.trim();
    this.emailControl.markAsTouched();

    try {
      const lookupResult = await this.userLookupService.lookupUserByEmail(email);
      if (lookupResult.loginIntegrationEnabled) {
        this.emailControl.setErrors({ loginIntegrationEnabled: true });
        return;
      }

      await this.authenticationService.sendPasswordRecoveryEmail(email);
      this.router.navigateByUrl(`/login/recuperar-senha/${email}`);
    } catch (err) {
        const code = getErrorCode(err);
        if (code === 'UserNotFoundException') {
          this.emailControl.setErrors({ userNotFound: true });
          return;
        }

        if (code === 'LimitExceededException') {
          this.emailControl.setErrors({ attemptsExceed: true });
          return;
        }

        if (err.error.message === 'User is disabled') {
          this.emailControl.setErrors({ userDisabled: true });
          return;
        }

      this.emailControl.setErrors({ unknown: true });
    } finally {
      this.isLoading = false;
      this.fuseProgressBar.hide();
    }
  }
}
